import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/common/style/index.less"
import '../theme/index.css'
import ElementUI from 'element-ui';
import Icon from './components/Icon'
import BaiduMap from 'vue-baidu-map'
import i18n from '@/lang'

// import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false




Vue.use(ElementUI);

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: process.env.NODE_ENV === 'production' ? process.env.VUE_BAIDU_MAP_KEY : process.env.VUE_BAIDU_MAP_KEY_FOR_DEV
})

Vue.component('Icon', Icon);

Vue.mixin({
    methods: {
        linkToRouter(linkurl) {
            console.log(linkurl);
            // window.open(linkurl, '_blank');
            // location.href = linkurl;
            const linkSplit = linkurl.split('#')[1];
            const linkParams = linkSplit.split('?');
            const path = linkParams[0];
            const linkQuery = linkParams[1] || '';
            let query = {};
            if (linkQuery) {
                const linkQueryArr = linkQuery.split('&');
                linkQueryArr.forEach(element => {
                    const queryObj = element.split('=');
                    query[queryObj[0]] = queryObj[1];
                });
            }

            this.$router.push({ path, query });
        }
    }
});

export const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')